import React, { Component } from 'react'
import H1 from '../../components/H1'
import VideoPlayer from '../../components/VideoPlayer'
import LazyLoad from 'react-lazyload'
import '../../styles/css/film.css'

const section = {
  target: 'film',
  title: 'Film Portfolio'
}

export default class Film extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      videoPlayer: false,
      video: 0,
      videos: [],
      limit: 99999
    }
  }

  componentDidMount = () => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if(isMobile) {
      this.setState({ limit: 5 })
    }
  }

  componentWillReceiveProps = nextProps => {
    this.setState({
      videos: nextProps.videos
    })
  }

  playVideo = index => {
    if(document.getElementsByTagName('audio').length) {
      document.getElementsByTagName('audio')[0].pause()
    }
    document.body.style.overflow = "hidden"
    this.setState({
      videoPlayer: true,
      video: index
    })
  }

  cancelVideoPlayer = () => {
    document.body.removeAttribute("style")
    this.setState({
      videoPlayer: false
    })
  }

  showAllVideos = () => {
    this.setState({ limit: this.props.videos.length + 1 })
  }

  render() {
    const { videos } = this.props
    const { limit } = this.state
    return(
      <div className="film">
        <div className="film-content">
            <H1 section={section} />
          <div className="films">

            {this.state.videoPlayer && 
                  <VideoPlayer 
                      videos={this.state.videos} 
                      currentVideo={this.state.video} 
                      onCancel={this.cancelVideoPlayer} 
            />}
              
              {videos && videos.slice(0,limit).map((video,index) =>
                <div className="film-item" key={index} onClick={() => this.playVideo(index)}>
                  <div className="film-item-header">
                    <LazyLoad once offset={100} height={100}>
                      <div className="thumbnail-wrapper">
                        <div className="film-item-thumbnail" style={{backgroundImage:`url('${video.thumbnail})`}}></div>
                        <button onClick={() => this.playVideo(index)} className="play-regular">Play video</button>
                        <button className="play-mobile"></button>
                      </div>
                    </LazyLoad>
                  </div>
                  <div className="film-item-body">
                      <h2>{video.name}</h2>
                  </div>
                </div>
              )}

              {limit <= videos.length && <button className="show-all" onClick={this.showAllVideos}>Show all videos</button>}
    
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/home/film.js